import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from "@angular/core";
import { ForgeInlineMessageModule } from "@tylertech/forge-angular";
import { ODataFilterFactoryService } from "@tylertech/odata-module";
import { Utilities } from "@tylertech/shared-module";
import { Align, PropertyMetadata } from "@tylertech/tyler-api-types";
import { CodeLookupService } from "../../../../services";

const DEFAULT_THEME: string = "info-primary";
@Component({
    selector: "metadata-inline-message",
    templateUrl: "./metadata-inline-message.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ForgeInlineMessageModule]
})

export class MetadataInputInlineMessageComponent implements OnInit
{
    private $codeLookupService = inject(CodeLookupService);
    private readonly $odataFilterFactory = inject(ODataFilterFactoryService);

    @Input()
    model: string;

    @Input()
    propertyMetadata: PropertyMetadata;

    @Input()
    formattedModel: string;

    loading: boolean = false;


    ngOnInit(): void
    {
        const self = this;
        this.loading = true;
        this.getValue(this.model, this.propertyMetadata)
            .then(v =>
            {
                self.model = self.formattedModel;
                self.loading = false;
            });
    }

    getValue(value: any, property: PropertyMetadata): Promise<string>
    {
        if (Utilities.IsNullOrUndefined(value)) return Promise.resolve("");
        if (property.Lookup)
        {
            let fieldValue = "";
            const builder = this.$odataFilterFactory.createBuilder();
            builder.filterEQ("Key", value);
            return this.$codeLookupService.Get(property.Lookup, builder.build())
                .then(
                    x =>
                    {
                        if (x && x.length > 0) fieldValue = x[0].Value;
                        return fieldValue;
                    },
                    () =>
                    {
                        return "Error Loading";
                    }
                );
        }
        return Promise.resolve(value.toString());
    }

    get value(): string
    {
        return !Utilities.IsNullOrUndefinedOrEmpty(this.model) ? this.formattedModel : "n/a";
    }

    get theme(): string
    {
        return Utilities.IsNullOrUndefined(this.propertyMetadata.Theme) ? DEFAULT_THEME : this.propertyMetadata.Theme;
    }

    classes(): string
    {
        let align = "align-left";
        if (this.propertyMetadata.Alignment)
        {
            switch (this.propertyMetadata.Alignment)
            {
                case Align.Right:
                    align = "align-right";
                    break;
                case Align.Center:
                    align = "align-center";
                    break;
                default:
                    break;
            }
        }
        return align;
    }
}
